var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-input-field',_vm._g(_vm._b({attrs:{"value":_vm.value,"pattern":_vm.pattern},on:{"blur":_vm.timeInputAutoFormat,"input":function($event){return _vm.$emit('input', _vm.value)}}},'ds-input-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }